/**
 * The modified spacing tokens from Styled System.
 * @see https://styled-system.com/getting-started#space-theming
 */
const SPACING_UNIT = 4;
const SPACING_VALUES = [
  0,
  SPACING_UNIT,
  SPACING_UNIT * 2,
  SPACING_UNIT * 3,
  SPACING_UNIT * 4,
  SPACING_UNIT * 5,
  SPACING_UNIT * 6,
  SPACING_UNIT * 7,
  SPACING_UNIT * 8,
  SPACING_UNIT * 9,
  SPACING_UNIT * 10,
];

/**
 * A utility that generates a value from the spacing system.
 *
 * These values are modelled from the default spacing system of the
 * Styled System. Styled System was used in the previous Design System
 * at Webflow. It's use is still scattered throughout codebase. Although
 * the mechanics of Styled System's spacing isn't bad (by any means), it
 * may be one what we would modify in the future as we establish our
 * own spacing system.
 *
 * 2021-09-16
 *
 * @see https://styled-system.com/getting-started#space-theming
 */
export function space(value?: number | string): string | null | undefined {
  if (typeof value === 'string') return value;
  if (typeof value === 'number') {
    const next = SPACING_VALUES[value] || value;
    return `${next}px`;
  }
  return undefined;
}

export default space;
